import TitleSection from 'components/common/TitleSection';
import CountUp from 'components/common/CounterSection';

const SuccessStoriesRating = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'Success stories',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  return (
    <section className='relative DBlock py-12 px-6 md:px-10'>
      <div className='max-w-7xl mx-auto'>
        <div className='DBlock'>
          <TitleSection titleDetail={titleDetail} />
        </div>
        <div className='DBlock'>
          <div className='max-w-6xl mx-auto grid place-items-center grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-12'>
            <div className='lg:col-span-1 lg:order-1'>
              <img
                className='w-full'
                src='/assets/images/about-us/successRating.png'
                alt='ratingImg'
              />
            </div>
            <div className='DBlock lg:col-span-2'>
              <CountUp />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStoriesRating;
